import { render } from "./TcrmDetails.vue?vue&type=template&id=cfde5b10"
import script from "./TcrmDetails.vue?vue&type=script&lang=js"
export * from "./TcrmDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__